import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl} from '@mui/material';
import React from 'react'
import { CuisineDishService } from '../../services/CuisineDishService';
import EventBus from '../../EventBus';
import { EventBusEventsEnum } from '../../enums/EventBusEventsEnum';
import { CustomSnackbarTypes } from './CustomSnackBar';
import moment from 'moment';

let cuisineService = new CuisineDishService();
function UploadDishImageDialog(props: any) {
    let [image, setImage] = React.useState<any>(null);
    let [imageUrl, setImageUrl] = React.useState<any>(null);

    const onImageSelect = (event: any) => {
        const file = event.target.files[0];
        if (!file) return;
        const extension = file.name.split('.').pop();
        const timestamp = moment().format("DDMMYYYYHHmmss");
        const fileName = `${props?.data?.name.replace(/\s/g, '')}_${timestamp}.${extension}`;
        cuisineService
        .getAWSLinks(fileName)
          .then((res) => {
            setImage(URL.createObjectURL(file));
            setImageUrl(res?.getUrl);
            cuisineService
              .uploadImageToAWS(res?.putUrl, file)
              .then((res) => {
                EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                  message: "Image uploaded successfully",
                  type: CustomSnackbarTypes.SUCCESS,
                });
              })
              .catch((err) => {
                EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                  message: "Something Went Wrong",
                  type: CustomSnackbarTypes.ERROR,
                });
              });
          })
          .catch((err) => {
            EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
              message: "Something Went Wrong",
              type: CustomSnackbarTypes.ERROR,
            });
          });
      };

    let handleSubmit = () => {
        if (!imageUrl) {
        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
            message: "Please select an image",
            type: CustomSnackbarTypes.ERROR,
        });
        return;
        }
        cuisineService.updateDishData(props?.data?.id, { image: imageUrl }).then(()=> {
            EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                message: `Image ${props?.data?.image ? 'updated' : 'added'} successfully`,
                type: CustomSnackbarTypes.SUCCESS,
            });
            setImageUrl(null);
            props.callBack();
            window.location.reload();
        }).catch((err) => {
            console.error(err);
            EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                message: "Something Went Wrong",
                type: CustomSnackbarTypes.ERROR,
            });
        })
    }
  return (
    <div>
        <Dialog open={props.open} scroll={"paper"}>
        <DialogTitle>{props?.data?.image ? 'Update Image' : 'Add Image'}</DialogTitle>
        <DialogContent>
          <FormControl fullWidth >
            <div>Select Image</div>
            <input
                accept="image/*"
                onChange={onImageSelect}
                name="profilePhoto"
                id="profilePhoto"
                type="file"
            />

            <div style={{ marginTop: '1rem' }}>
              {image && (
                <img
                  src={image}
                  alt="Selected"
                  style={{
                    width: '100%',
                    height: 'auto',
                    borderRadius: '8px',
                    objectFit: 'cover',
                  }}
                />
              )}
            </div>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color={"success"}
            onClick={() => {
              handleSubmit();
            }}
            size={"large"}
          >
            Submit
          </Button>
          <Button
            variant="contained"
            color={"error"}
            onClick={() => {
              props.callBack();
            }}
            size={"large"}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
      
    </div>
  )
}

export default UploadDishImageDialog
